<template>

  <div class="resume"
       :class="{active:state.resume,'bg-habitation':$route.name=='HouseType','bg-region':$route.name=='RegionSelection','bg-room':$route.name=='RoomType'&&state.known_power}">

    <div class="header">

      <a href="/">
        <img src="../assets/img/logo_white.svg" class="logo">
      </a>
      
      <span class="text-white">
        Besoin d’aide ? <br class="d-md-none">
        <a class="text-white" href="tel:03 89 37 75 00">03 89 37 75 00</a>
      </span>
    </div>

    <div class="resume-wrapper" v-if="showResumeBox"
         :class="{'yellow-filter': $route.name!=='FirstChoice'&&((showRoomBox&&state.known_power)||!state.known_power)}">

      <div class="rounded bg-white p-4 mb-5">

        <div class="fa-2x loading" v-if="loading">
          <i class="far fa-circle-notch fa-spin text-primary"></i>
        </div>
        
        <i v-if="!state.resumeLast" class="fal fa-times float-right fa-lg text-secondary d-md-none" @click="setData('resume',false)"></i>

        <template v-if="!addedToCart">
          <p class="h3 mb-3">Récapitulatif</p>
          
          <div class="mb-3" v-if="!state.known_power">
            <p class="text-primary mb-0">Habitation</p>
            <div class="border-left pl-3">
              <p class="lead font-weight-normal mb-0">{{ getHouse(state.house_type) }}</p>
              <span class="text-secondary" v-if="state.selected_region">{{ state.selected_region.title }}</span>
            </div>
          </div>

          <div :class="{'mb-3' : showRadiators && state.selected_config.radiators}" v-if="showRoomBox">
            <p class="text-primary mb-0">Pièce</p>
            <div class="border-left pl-3" v-if="state.known_power">
              <span class="lead font-weight-normal mb-0">{{ getRoom(state.room_type) }} </span>
              <span class="text-secondary" v-if="state.power_selected">{{ state.power_selected }} W</span>
            </div>
            <template v-else>
              <span class="lead font-weight-normal mb-0">{{ getRoom(state.room_type) }} </span><span
                class="text-secondary">{{ state.surface }} m<sup>2</sup></span>
            </template>
          </div>

          <ul class="mb-0 list-unstyled radiator-list" v-if="showRadiators&&state.selected_config.radiators" :class="{'mb-3' : showPiloting && state.piloting || state.resume }">
            <li class="mb-1 bg-light p-3" v-for="(radiator,i) in state.selected_config.radiatorsFetched">
              <div class="d-flex align-items-center pb-2">
                <img class="radiator-img" :src="require('@/assets/img/radiateurs/'+the_image(radiator))">
                <span class="lead font-weight-normal d-inline-block mr-3">Radiateur n°{{i+1}}
                  <p class="text-secondary mb-0 mt-n1" v-if="state.radiator.orientation=='horizontal'"><small>{{ radiator.width }}cm x {{radiator.height}}cm x 8cm</small></p>
                  <p class="text-secondary mb-0 mt-n1" v-else><small>{{ radiator.height }}cm x {{radiator.width}}cm x 8cm</small></p>
                </span>
                <span class="text-secondary d-flex align-items-center" v-if="showColors&&state.radiator.color"><span
                    class="color-pellet"
                    :class="state.radiator.color.class"></span> {{ state.radiator.color.name }}</span>
              </div>
              <div class="row" :class="{'pb-2' : showThermostat && state.radiator.towelDryers}">
                <div class="col-3">
                  <p class="mb-0">Puissance</p>
                  <p class="text-secondary mb-0">{{ radiator.power }}W</p>
                </div>
                <div class="col-5 pl-3" v-if="showFinition&&state.radiator.finition">
                  <p class="mb-0">Finition</p>
                  <p class="text-secondary mb-0">{{ state.radiator.finition }}</p>
                </div>
                <div class="col-4 pl-0" v-if="showThermostat&&state.radiator.thermostat">
                  <p class="mb-0">Thermostat</p>
                  <p class="text-secondary mb-0">{{ state.radiator.thermostat }}</p>
                </div>
              </div>
              <div v-if="showThermostat&&state.radiator.towelDryers!=='0'">
                <i class="far fa-grip-lines mr-1" v-if="state.radiator.towelDryers == 2"></i>
                <i class="far fa-bars mr-1" v-if="state.radiator.towelDryers == 3"></i>
                {{ state.radiator.towelDryers }} barres sèche serviettes
              </div>
            </li>
          </ul>

          <div :class="{'mb-3' : state.resume}" v-if="showPiloting&&state.piloting">
            <i class="far fa-check"></i> Avec l'option de pilotage à distance
          </div>
          <template v-if="state.resumeLast">
            <button class="btn btn-md btn-primary rounded-pill w-100 mb-2" @click="submit">
              Ajouter au panier
            </button>
<!--            <button class="btn btn-md btn-primary rounded-pill w-100 mb-3" @click="submit">-->
<!--              Recommencer la configuration-->
<!--            </button>-->

            <div class="text-center">
              <a @click="setData('resume',false);setData('resumeLast',false);" class="mb-0 return"><i class="fal fa-arrow-left"></i> <span>retour</span></a>
            </div>
          </template>
        </template>
        <!-- Après avoir cliqué sur ajouter au panier -->
        <div class="text-center py-5" v-if="addedToCart">

          <div class="icon icon--order-success svg">
            <svg xmlns="http://www.w3.org/2000/svg" width="85px" height="85px">
              <g fill="none" stroke="#FDC400" stroke-width="3">
                <circle cx="36" cy="36" r="35"
                        style="stroke-dasharray:240px, 240px; stroke-dashoffset: 480px;"></circle>
                <path d="M17.417,37.778l9.93,9.909l25.444-25.393"
                      style="stroke-dasharray:50px, 50px; stroke-dashoffset: 0px;"></path>
              </g>
            </svg>
          </div>

          <h1 class="h3 mt-4">Les produits ont été ajoutés<br>à votre panier</h1>
            <router-link :to="{name:'FirstChoice'}" class="btn btn-md btn-primary rounded-pill w-100 mt-4" @click.native="addedToCart=false;setData('resume',false);">
              <i class="fal fa-plus fa-lg"></i> Configurer une nouvelle pièce
            </router-link>

          <a href="/panier" target="_blank" class="btn btn-secondary rounded-pill mt-4 px-3">
            Voir mon panier
          </a>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import pnl from "@/mixins/pnl";
export default {
  name: "SideResume",
  mixins: [pnl],
  data() {
    return {
      addedToCart: false,
      loading:false,
    }
  },
  methods: {
    async submit() {
      this.loading = true;
      let ids = await this.initCart();
      await this.addToCart(ids);
      this.addedToCart = true;
      this.resetStore();
    },
    resetStore(){
      this.setData('sent', true)
      this.setData('known_power', null)
      this.setData('room_type', null)
      this.setData('surface', 10)
      this.setData('radiator', {
        color: null,
        orientation: 'horizontal',
        finition: 'Brillant',
        thermostat: null,
        towelDryers: '2',
      })
      this.setData('piloting', true);
      this.setData('configurations',[]);
      this.setData('selected_config',[]);
      this.setData('power_selected',1000);
      //trois lignes suivantes ajoutées si pas d'ajout au panier
      // this.setData('resume',false);
      // this.setData('resumeLast',false);
      // this.$router.push({name:'FirstChoice'});
    },
    countOccurrences(arr, val) {
      return arr.reduce((a, v) => (v === val ? a + 1 : a), 0);
    },
    async addToCart(ids){
      let url = window.location.origin+'/?multiple-item-to-cart=';
      let singles = new Set(ids)
      singles.forEach(id=>{
        url+=id+':'+this.countOccurrences(ids,id)+'|';
      })
      url = url.slice(0,-1)
      console.log(url)
      await axios.get(url)
      this.loading = false;
    }
  },
  computed: {
    showResumeBox() {
      return (this.$route.name !== 'FirstChoice' && this.$route.name !== 'HouseType' && this.$route.name !== 'RegionSelection' && !this.state.known_power)
          || (this.state.known_power && this.$route.name !== 'RoomType' && this.$route.name !== 'FirstChoice')
    },
    showRoomBox() {
      return this.$route.name !== 'RoomType'
    },
    showRadiators() {
      return this.showRoomBox && this.showResumeBox && this.$route.name !== 'SurfaceSelection' && this.$route.name !== 'PowerSelection' && this.$route.name !== 'PowerShow'
    },
    showColors() {
      return this.showRadiators && this.$route.name !== 'PowerShow' && this.$route.name !== 'OrientationSelection'
    },
    showFinition() {
      return this.showColors && this.$route.name !== 'ColorSelection'
    },
    showThermostat() {
      return this.showFinition && this.$route.name !== 'FinitionSelection' && this.$route.name !== 'ThermostatSelection'
    },
    showPiloting() {
      return this.showThermostat && this.$route.name !== 'TowelSelection'
    },
  }
}
</script>

<style scoped>

</style>